import { render } from "./PlanoList.vue?vue&type=template&id=e799a520"
import script from "./PlanoList.vue?vue&type=script&lang=js"
export * from "./PlanoList.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__